import React from 'react';
export function SectionImage() {
  return <section className="w-full" data-id="element-114">
      <img src="https://cdn.shopify.com/s/files/1/1019/9361/1596/files/hf_20260302_213840_39d21cb6-8b5a-46d8-9339-2bc47ff6d1e0.jpg?v=1772970715" alt="Sección promocional" className="w-full block" style={{
      display: 'block'
    }} data-id="element-115" />
    </section>;
}